import { useState } from "react";
import { Briefcase, Percent, Coins, Sparkles } from "lucide-react";
import { useCollection } from "@/hooks/useCollection";
import { rupiah, sum, todayIso, fmtDate, monthKey, INCOME_TYPES } from "@/lib/format";
import { EntryForm, ItemList, Section, Stat } from "./shared";

const ICONS = { salary: Briefcase, commission: Percent, tips: Coins, other: Sparkles };
const HINT = { salary: "gaji bulananku", commission: "komisi kerjaku", tips: "tips harianku", other: "pemasukan lainnya" };

export default function IncomeTab() {
  const [filter, setFilter] = useState("salary");
  const { items, add, remove } = useCollection("incomes");
  const shown = filter === "all" ? items : items.filter((x) => x.type === filter);
  const m = monthKey();
  const monthTotal = (t) => sum(items.filter((x) => x.type === t && x.date.startsWith(m)));

  return (
    <div className="space-y-4" data-testid="duitku-income">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {Object.entries(INCOME_TYPES).map(([k, l]) => <Stat key={k} label={`${l} bulan ini`} value={rupiah(monthTotal(k))} tone="text-pink-500" testid={`income-month-${k}`} />)}
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {[["all", "Semua"], ...Object.entries(INCOME_TYPES)].map(([k, l]) => (
          <button key={k} onClick={() => setFilter(k)} className={`chip ${filter === k ? "chip-on" : "chip-off"}`} data-testid={`income-filter-${k}`}>{l}</button>
        ))}
      </div>
      <Section title={filter === "all" ? "Catat pemasukan" : `Catat ${HINT[filter]}`}>
        <EntryForm
          key={filter}
          testid="income-form"
          initial={{ type: filter === "all" ? "salary" : filter, amount: "", date: todayIso(), note: "" }}
          fields={[
            { name: "type", label: "Jenis", type: "select", options: Object.entries(INCOME_TYPES), keep: true },
            { name: "amount", label: "Jumlah (Rp)", type: "number", required: true, min: 1 },
            { name: "date", label: "Tanggal", type: "date", required: true, keep: true },
            { name: "note", label: "Catatan", placeholder: "mis. Gaji bulan ini" },
          ]}
          onSubmit={(v) => add({ ...v, amount: Number(v.amount) })}
        />
        <div className="mt-4">
          <ItemList
            testid="income-list"
            items={shown}
            onDelete={remove}
            empty="Belum ada pemasukan. Yuk catat yang pertama!"
            render={(it) => {
              const I = ICONS[it.type];
              return {
                icon: <span className="w-9 h-9 rounded-2xl bg-pink-100 text-pink-500 grid place-items-center shrink-0"><I className="w-4 h-4" /></span>,
                title: it.note || INCOME_TYPES[it.type],
                subtitle: `${INCOME_TYPES[it.type]} · ${fmtDate(it.date)}`,
                right: <span className="text-sm font-semibold text-emerald-500 whitespace-nowrap">+{rupiah(it.amount)}</span>,
              };
            }}
          />
        </div>
      </Section>
    </div>
  );
}
